// Presentation mapping for live product data (@astro/api catalog → card props).
// The old hardcoded PRODUCTS array is gone — the slider fetches from
// GET /v1/featured-products and decorates each record here.

/** Badge styling per category, matched loosely on the category name. */
const BADGE_RULES = [
  { match: /rudraksha/i, badgeClass: 'ps-badge-rudraksha', emoji: '🌿' },
  { match: /yantra/i, badgeClass: 'ps-badge-yantra', emoji: '📿' },
  { match: /puja|samagri/i, badgeClass: 'ps-badge-puja', emoji: '🔥' },
  { match: /gem|stone|sapphire|ruby|emerald/i, badgeClass: 'ps-badge-gem', emoji: '💎' },
]

export const categoryBadge = (categoryName) => {
  const rule = BADGE_RULES.find((r) => r.match.test(categoryName ?? ''))
  return rule ?? { badgeClass: 'ps-badge-gem', emoji: '✦' }
}

const stripHtml = (html) =>
  String(html ?? '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&rsquo;|&#39;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/\s+/g, ' ')
    .trim()

const formatPrice = (value) => {
  const num = Number(value)
  if (!Number.isFinite(num) || num <= 0) return 'On Request'
  return `₹${num.toLocaleString('en-IN')}`
}

/** Shape a live API product into the props ProductCard renders. */
export function decorateProduct(record) {
  const category = record.categories?.[0]?.name ?? 'Sacred Item'
  const { badgeClass } = categoryBadge(category)

  const ratti = Number(record.ratti)
  const discount = Number(record.discount_rate)
  const tags = [
    ratti > 0 && `${record.ratti} Ratti`,
    record.origin_name && `${record.origin_name} Origin`,
    discount > 0 && `${discount}% Off`,
  ].filter(Boolean)

  return {
    id: record.id,
    slug: record.slug,
    category,
    badgeClass,
    badgeLabel: category,
    image: record.image_url,
    name: record.name,
    description: stripHtml(record.sort_description),
    origin: record.origin_name ?? null,
    tags,
    price: formatPrice(record.final_price ?? record.price),
    available: Number(record.stock) > 0,
  }
}
